import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Storage} from '@ionic/storage';
import {APP_CONDITION_ITEMS} from '../../../environments/environment';
import {FormControl, FormGroup} from '@angular/forms';
import {SessionDataService} from '../../provider/session-data/session-data.service';
import {Subscription} from 'rxjs';
import {StorageService} from '../../provider/storage/storage.service';

@Component({
	selector: 'app-regisafe-datastores',
	templateUrl: './regisafe-datastores.component.html',
	styleUrls: ['./regisafe-datastores.component.scss'],
})
export class RegisafeDatastoresComponent implements OnInit {

	// emit Data to parent Component
	@Output() updatedSelectedStorages: EventEmitter<any> = new EventEmitter<any>();

	subscription: Subscription;
	dataStores: Array<any> = [];
	dataStoresForm = new FormGroup({});

	constructor(private storage: Storage,
				private storageService: StorageService,
				private sessionData: SessionDataService) {

	}

	ngOnInit() {
		this.getDataStores();
	}

	/**
	 * get the DataStores from SessionData or, if not set, from Storage
	 */
	async getDataStores() {

		const dataStores = await this.storageService.getConditions(APP_CONDITION_ITEMS.dataStores);

		if (dataStores && dataStores.length > 0) {
			console.log('getDataStores: ', dataStores);
			this.dataStores = dataStores;
			this.initDatastoresForm(dataStores);

		} else {
			console.log('getDataStores error: ');
			this.dataStores = [];
			this.sessionData.dataStores = [];
		}

	}

	/**
	 * init DataStores Form
	 *
	 * @param storesArr - DataStores Array from SessionData or Storage
	 */
	initDatastoresForm(storesArr: Array<any>) {
		const group = {};
		storesArr.forEach((formItem) => {
			group[formItem.name] = new FormControl(formItem.isActive);
		});

		this.dataStoresForm = new FormGroup(group);
		this.setDataStoresToSessionAndEmitToParent();
	}

	/**
	 * Change SessionData for Datastores and emit data to Parent Component
	 *
	 * @param event - get infos from input element (checkbox)
	 * @param index - index of the changed element
	 */
	setDataStoresToSessionAndEmitToParent() {
		// clean Cache
		this.sessionData.searchResultCache.stateURL = '';
		this.sessionData.searchResultCache.data = {};
		// Get Formvalues and emit to Parent
		this.sessionData.dataStores = this.dataStoresForm.value;
		this.updatedSelectedStorages.emit(this.dataStoresForm.value);
	}

}
